module.exports = __webpack_public_path__ + "img/gal-5.204fa59f.jpg";